<app-banner-app [retroSelected]="true" [Parametros]="this.parametro" [PaginaAnterior]="'InfoArriendo'"
    [IdentLead]="this.leadId" [codAsesor]="this.codAsesor" [bitacoraId]="this.IdBitacora">

</app-banner-app>

<div class="descktop">
    <br><br><br><br>
</div>

<div style="background-color: #2D6DF6;">
    <div class="row" style="width: 100%;">
        <div class="col-sm-5">
            <div class="descktop">
                <div class="img-container">
                    <img class="styleImage" src="./assets/img/llaveCasaSinFondo.png" />
                </div>
            </div>
        </div>

        <div class="col-sm-6">
            <br>
            <main class="form-signin w-100 m-auto">
                <p class="tituloEncabezado">Elige la duración del contrato de arriendo</p><br>

                <form [formGroup]="formulario">

                    <button type="button" class="btn btn-primary estiloPrincipal estiloEspecial"
                        (click)="duracionContrato(12)" [disabled]="desbilitar6">
                        <strong>12 meses</strong>
                    </button>
                    <br><br>

                    <button type="button" class="btn btn-primary estiloPrincipal estiloEspecial"
                        (click)="duracionContrato(6)" [disabled]="desbilitar12">
                        <strong>6 meses</strong>
                    </button>
                    <small *ngIf="swValidacionDuracion" class="tipoLetra" style="color: white;">Debes selecionar una
                        duración para el contrato. <br></small>
                    <br><br>

                    <p class="informacionProp estiloTextos">¿Cuándo inicia el contrato de arriendo?
                    </p>

                    <input type="date" style="color: #0033A0;" class="form-control estiloPrincipal"
                        placeholder="AAAA/MM/DD" name="datepicker" id="datepicker" [ngModel]="model"
                        formControlName="datepicker" min="{{ this.fechaMin }}" max="{{ this.fechaMax }}" required
                        (focusout)="ValidarFechaContrato()">

                    <small *ngIf="fechaNoValida" class="text-danger" style="font-family: SuraSans-Regular;">
                        Debe seleccionar una fecha valida*
                    </small>
                    <small *ngIf="swValidacionSeleccionarFecha" class="tipoLetra" style="color: white;">Debes Selecionar
                        una fecha para el inicio del contrato. <br></small>
                    <small *ngIf="swValidacionFechaSupera" class="tipoLetra" style="color: white;">La fecha del contrato
                        no puede superar el mes de vigencia. <br></small>
                    <small *ngIf="swValidacionFechaInferior" class="tipoLetra" style="color: white;">La fecha del
                        contrato no puede ser inferior a la actual.</small>
                    <br><br>

                    <div class="estiloControles">
                        <button type="button" class="btn btn-warning estiloBoton" (click)="PlanesSeguros()">
                            <strong>Ver planes</strong>
                        </button>
                    </div>

                    <br><br><br>

                </form>
            </main>
        </div>
    </div>

    <app-footer-app></app-footer-app>
</div>